import { computed, readonly, ref } from 'vue'

const projectSummaryContainerCounter = ref(0)
const hasProjectSummaryContainer = computed(() => projectSummaryContainerCounter.value > 0)
const isNormalFooterVisible = ref(false)
const normalFooterHeight = ref(0)
const scrollbarWidth = ref(0)

function registerProjectSummaryContainer() {
  projectSummaryContainerCounter.value += 1
}

function unregisterProjectSummaryContainer() {
  projectSummaryContainerCounter.value = Math.max(0, projectSummaryContainerCounter.value - 1)
}

function setNormalFooterVisible(visible: boolean) {
  isNormalFooterVisible.value = visible
}

function setNormalFooterHeight(height: number) {
  normalFooterHeight.value = Math.max(0, Math.round(height))
}

function setScrollbarWidth(width: number) {
  scrollbarWidth.value = Math.max(0, Math.round(width))
}

export function useFooterLayoutState() {
  return {
    hasProjectSummaryContainer: readonly(hasProjectSummaryContainer),
    isNormalFooterVisible: readonly(isNormalFooterVisible),
    normalFooterHeight: readonly(normalFooterHeight),
    scrollbarWidth: readonly(scrollbarWidth),
    registerProjectSummaryContainer,
    unregisterProjectSummaryContainer,
    setNormalFooterVisible,
    setNormalFooterHeight,
    setScrollbarWidth,
  }
}
